import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import React from "react";
import Pagination from "rc-pagination";
import "assets/index.less";
// import '../../rc-select/assets/index.less';
import { useParams } from "react-router-dom";
import { productDataToQuery } from "utils/helperFunctions";
import ProductCaption from "components/product/ProductCaption";
import "components/product/product.css";
import Product from "common/product/Product";
import GroupView from "common/Group-View/GroupViewItem";

import hard from "assets/images/hard.png";
import laptop from "assets/images/laptop1.png";
import headphone from "assets/images/headphone.png";
import sendRequest from "hooks/useAxios";
export default function SpecificProducts() {
  const params = useParams();
  const [product, setProduct] = useState({
    captionName: "جدیدترین محصولات ",
    item: [],
  });
  const [currentPage, setCurrentPage] = useState(1);

  const sliceArray = (array) => {
    return array.slice((currentPage - 1) * 12, (currentPage - 1) * 12 + 12);
  };

  let queryObj = {};
  if (params.query) {
    queryObj = productDataToQuery(params.query, true);
  } else {
    queryObj.title = "تمامی محصولات";
  }
  // const [queryObj, setQueryObj] = useState();

  useEffect(() => {
    const sendRequestBasedParams = () => {
      if (params.query) {
        return sendRequest("productfilter", {
          hashtags: queryObj.tags.toString(),
          brandId: queryObj.brands.toString(),
          fromRate: queryObj.rankRange[0],
          toRate: queryObj.rankRange[1],
          fromPrice: queryObj.priceRange[0],
          toPrice: queryObj.priceRange[1],
          discount: queryObj.sortTypes.discounted,
          ascendingPrice: queryObj.sortTypes.cheapest,
          descendingPrice: queryObj.sortTypes.mostExpensive,
          ascendingTime: queryObj.sortTypes.newest,
          inventoryCount: queryObj.sortTypes.inventory,
        });
      } else {
        return sendRequest("productfilter", {});
      }
    };

    sendRequestBasedParams().then(({ data }) => {
      console.log("product dasra: ", data.items);
      setProduct((prev) => {
        return {
          ...prev,
          item: data.items.reverse().map((data) => {
            return {
              image: data.url,
              title: "",
              name: data.title,
              brand: data.brand.length != 0 ? data.brand.name : "",
              score: data.avg_rating,
              score_count: data.rating_count,
              price: data.main_price,
              discount: data.main_discount,
              id: data.id,
            };
          }),
        };
      });
    });
  }, []);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{queryObj.title}</title>
        {/* <link rel="canonical" href="http://mysite.com/example" /> */}
      </Helmet>
      <ProductCaption
        captionName={queryObj.title}
        captionColor={"#ef394e"}
      ></ProductCaption>
      {product.item.length !== 0 ? (
        <GroupView
          Component={Product}
          items={sliceArray(product.item)}
          numberOf={product.item.length}
          title=""
          type={0}
          isFilteredPage={true}
          specificItems={sliceArray(product.item)}
          isNotEditable={true}
        />
      ) : (
        <span className="m-4 pt-4 fw-bold">آیتمی موجود نیست.</span>
      )}

      <Pagination
        className="text-center my-2"
        total={product.item.length}
        pageSize={12}
        hideOnSinglePage={true}
        current={currentPage}
        onChange={(page) => {
          setCurrentPage(page);
        }}
      />
    </div>
  );
}
